import React from "react";
import CotizacionAPersonalRecuperarAbierto from "../../components/CotizacionAccidentePersonal/CotizacionAPersonalRecuperarAbierto";

const ContainerCotizacionAPersonalRecAbierto =()=> 
 
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <CotizacionAPersonalRecuperarAbierto/>
          </div>
        </div>
      </main>
 

export default ContainerCotizacionAPersonalRecAbierto
